import { gsap } from "gsap";

export function fadeIn(targetEl, display = "block") {
  return new Promise((resolve) => {
    targetEl.style.display = display;
    targetEl.style.opacity = 0;
    gsap.to(targetEl, {
      opacity: 1,
      onComplete: resolve,
    });
  });
}

export function fadeOut(targetEl) {
  return new Promise((resolve) => {
    gsap.to(targetEl, {
      opacity: 0,
      onComplete: () => {
        targetEl.style.display = "none";
        resolve();
      },
    });
  });
}
